import {FetchEvents} from "./RequestGroup";
import {storageFunctions} from "../storage";
import {API_DOMAIN, API_SCHEMA} from "../env";

const URL_PREFIX = `${API_SCHEMA}${API_DOMAIN}/fa`;

export type JRes = {
    status: number,
    data: object,
    message: string
}

function internalErrorJRes(error: any): JRes {
    return {
        status: 500,
        message: "خطا داخلی در برقراری ارتباط با سرور",
        data: error
    } as JRes;
}

function _generateUrl(prefix: string, address: string, params: any|null) {
    return URL_PREFIX + address + ((params != null) ? ('?' + new URLSearchParams(params)) : "");
}

function _generateHeader({method = "GET", token = null, body = null, conType = "application/json"}: headerParams) {
    const headers = {
        method: method,
        headers: {
            'Accept': 'application/json'
        },
        mode: "cors"
    } as RequestInit;

    if (token != null) // @ts-ignore
        headers.headers["Authorization"] = 'Bearer ' + token;
    if (method == "POST" && body != null) // @ts-ignore
        headers.body = body;
    if (conType != null) // @ts-ignore
        headers.headers['Content-Type'] = conType;

    return headers;
}

interface headerParams {
    method?: "GET" | "POST",
    token?: string | null,
    body?: object | string | null,
    conType?: "application/json" | null
}

function _startFetch (address: string, params: object|null, headers: any, events: FetchEvents) {
    fetch(_generateUrl(URL_PREFIX, address, params), headers)
        .then(response => response.json())
        .then(json => {
            events.onResponse(json as JRes);
            if (json.status == 200)
                events.onSuccess(json.data);
            else {
                events.onError(json.message, json.status);
                events.onPromiseReject(json.message);
            }
        })
        .catch(error => {
            events.onResponse(internalErrorJRes(error));
            // Todo: use text class
            events.onError("خطا داخلی در برقراری ارتباط با سرور",  400)
            events.onPromiseReject("خطا داخلی در برقراری ارتباط با سرور");
        });
}

const makeFormDataPost = (address: string, data: any, files: { name:string, file:any }[], params: object|null, events: FetchEvents, auth = false) => {
    const form = new FormData();
    form.append("data", JSON.stringify(data));
    files.forEach((item, index) => {
        if (item.file != null)
            form.append(item.name, item.file);
    });

    const startFetch = (headers: any) => _startFetch(address, params, headers, events);

    if (auth)
        storageFunctions.getData("api_key").then(token => {
            events.onStart();
            startFetch(_generateHeader({method: "POST", body: form, conType: null, token: token}));
        }).catch((e) => {
            events.onError("Cant get api-key", 400);
            events.onPromiseReject("Cant get api-key");
            startFetch(_generateHeader({method: "POST", body: form, conType: null}));
        });

    else {
        events.onStart();
        startFetch(_generateHeader({method: "POST", body: form, conType: null}));
    }

}

const makePost = (address: string, input: object, params: object|null, events: FetchEvents, auth = false) => {

    const startFetch = (headers: any) => _startFetch(address, params, headers, events);

    if (auth)
        storageFunctions.getData("api_key").then(token => {
            events.onStart();
            startFetch(_generateHeader({method: "POST", token: token, body: JSON.stringify(input)}));
        }).catch((e) => {
            events.onError("Cant get api-key", 400);
            events.onPromiseReject("Cant get api-key");
            startFetch(_generateHeader({method: "POST", body: JSON.stringify(input)}));
        });
    else {
        events.onStart();
        startFetch(_generateHeader({method: "POST", body: JSON.stringify(input)}));
    }
}

const makeGet = (address: string, params: object|null, events: FetchEvents, auth = false) => {
    const startFetch = (headers: any) => _startFetch(address, params, headers, events);

    if (auth) storageFunctions.getData("api_key").then(token => {
        events.onStart();
        startFetch(_generateHeader({token: token}));

    }).catch((e) => {
        events.onError("Cant get api-key", 400);
        events.onPromiseReject("Cant get api-key");
        startFetch(_generateHeader({}));
    });

    else {
        events.onStart();
        startFetch(_generateHeader({}));
    }
}

export {makePost, makeGet, makeFormDataPost, URL_PREFIX}